import { Link, createFileRoute } from '@tanstack/react-router';
import { Card } from '@/components/ui/card';
import { WikiAnchorSection } from '@/components/wiki/WikiAnchorSection';
import { WikiToc } from '@/components/wiki/WikiToc';

export const Route = createFileRoute('/wiki/dragons')({
  component: DragonsHubPage,
});

function DragonsHubPage() {
  const toc = [
    { id: 'dragons-guide', label: 'Main Guide' },
    { id: 'related-systems', label: 'Related Systems' },
  ];

  return (
    <div className="space-y-5">
      <WikiToc items={toc} />

      <WikiAnchorSection id="dragons-guide" title="Main Dragons Guide">
        <div className="grid gap-4 sm:grid-cols-[140px_1fr]">
          <img
            src="/images/nav/dragons@3x.png"
            alt="Dragons"
            className="w-full max-w-[140px] rounded-xl border border-[#d4af37]/25"
          />
          <div className="space-y-3">
            <p>
              The main dragons guide now lives as a top-level page so it can carry live current-age
              dragon effects alongside the kingdom rules for funding, launching, and slaying.
            </p>
            <Link
              to="/dragons"
              className="inline-flex rounded-lg border border-[#d4af37]/30 px-3 py-1.5 text-sm text-[#e6c547] hover:bg-[#d4af37]/12"
            >
              Open Dragons Guide
            </Link>
          </div>
        </div>
      </WikiAnchorSection>

      <WikiAnchorSection id="related-systems" title="Related Systems">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {[
            {
              to: '/kingdom-relations',
              title: 'Kingdom Relations',
            },
            {
              to: '/monarchy',
              title: 'Kingdom Monarchy',
            },
            {
              to: '/military',
              title: 'Military',
            },
            {
              to: '/actions/$actionId',
              title: 'Dragon Charm',
              params: { actionId: 'dragon_charm' as const },
            },
          ].map(item => (
            <Link
              key={item.title}
              to={item.to}
              params={'params' in item ? item.params : undefined}
            >
              <Card className="p-4 transition-colors hover:border-[#d4af37]/40">
                <h3 className="font-cinzel text-lg text-[#f0f0f0]">{item.title}</h3>
              </Card>
            </Link>
          ))}
        </div>
      </WikiAnchorSection>
    </div>
  );
}
